import React from 'react';
import PropTypes from 'prop-types';
import ChatBubble from '../../../assets/images/products/chat-speech-balloon.svg';
import UserBar from '../../../containers/loggedIn/Feed/common/UserBar';
import ProductRatingCard from '../ProductRatingCard';
import { twoDecimal } from '../../../utils/helper';
import ReadMoreText from '../../../containers/loggedIn/Feed/common/ReadMoreText';

function ProductReviewListItem({ review,
    handleReviewClick }) {
    const comment = review.review_comment,
        showCommentsCount = !!review.comment_count,
        commentCountText = showCommentsCount
            ? `${review.comment_count} comment${review.comment_count === 1 ? '' : 's'}`
            : 'Add a comment',
        profile = review.profile,
        createdAt = review.created_at,
        reviewMeta = review.review_meta
            ? review.review_meta
            : false,
        imageToShow = review.meta
            ? review.meta.original_photo
            ? review.meta.original_photo
            : null
            : null;
    return (<li className="product__reviews__list__item">
        <div className="product__reviews__list__item__left">
            <div>
                <UserBar profile={profile}
                    createdAt={createdAt}
                    showOptionsIcon={false} />
            </div>
            <div>
                { !!comment && <ReadMoreText text={comment} className="product__reviews__comment" /> }
                <button onClick={() => handleReviewClick(review)} className="product__reviews__comment-btn">
                    { !showCommentsCount && <img src={ChatBubble} alt="add a commment" />}
                    { commentCountText }
                </button>
            </div>
        </div>
        <div className={`product__reviews__list__item__right cursor-pointer ${imageToShow ? 'product__reviews__list__item__right--with-image' : ''}`}
            onClick={() => handleReviewClick(review)}>
            { reviewMeta && <ProductRatingCard maxRating={reviewMeta.max_rating}
                ratingToShow={twoDecimal(reviewMeta.user_rating)}
                containerClass="product__ratings__default"
                backgroundColor={reviewMeta.color_code} /> }
            { imageToShow && <img className="product__ratings__img" src={imageToShow} alt="review" />}
        </div>
    </li>)
};

ProductReviewListItem.propTypes = {
    review: PropTypes.object.isRequired,
    handleReviewClick: PropTypes.func
}

export default ProductReviewListItem;